import styled from 'styled-components';

// styled-components v5 types circularly reference defaultProps on TypeScript 4.9+.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styledComponent = (component: any) => styled(component);
